<div class="wa-stack">
  <wa-card class="card-header">
    <div slot="header" class="wa-flank:end">
      <span class="wa-heading-s">Excluded time periods for exam supervision ("Klausuraufsichten")</span>
      <span class="cluster wa-align-items-center wa-gap-xs">
        @if (voting_ongoing) {
          <wa-badge variant="success" appearance="filled outlined" pill>
              <wa-icon name="hand-point-right" label="open"></wa-icon>
              open now!
            </wa-badge>
        } @else if (voting_ended) {
          <wa-badge variant="danger" appearance="filled outlined" pill>
              <wa-icon name="octagon" label="deadline passed"></wa-icon>
              voting deadline passed
            </wa-badge>
        } @else {
          <wa-badge variant="warning" appearance="filled outlined" pill>
              <wa-icon name="hand-point-up" label="coming up"></wa-icon>
              coming up
            </wa-badge>
        } @if (survey().published) {
          <wa-badge variant="brand" appearance="filled outlined" pill>
              <wa-icon name="megaphone" label="published"></wa-icon>
              results published
            </wa-badge>
        }
      </span>
      @if (surveyActive()) {
        <wa-button class="wa-outlined wa-brand" size="s" (click)="addExclusionPreferenceDialog()">
          <wa-icon slot="start" name="plus" variant="solid"></wa-icon>
          add
        </wa-button>
      } @else {
      <wa-button class="wa-outlined wa-brand" size="s" [disabled]="true"
                 (click)="addExclusionPreferenceDialog()">
        <wa-icon slot="start" name="plus" variant="solid"></wa-icon>
        add
      </wa-button>
    }
    </div>
    @if (!exclusionPreferences.value()?.length) {
      <span>Right now, we assume that <strong>you are available throughout the whole examination period</strong> to supervise exams.</span>
      <br/><br/>
    } @else {
    <div class="wa-cluster tags-removable">
      @for (pref of exclusionPreferenceView(); track pref.id) {

        @if (surveyActive()) {
          <wa-tag ngModel variant="neutral" [withRemove]="true" (waRemove)="deleteExclusionPreference(pref)">
                <span>{{
                    {
                      from: pref.begin,
                      to: pref.end
                    } | dateRange: dateFormat
                  }}</span>&nbsp;—&nbsp;<span>{{ pref.note }}</span>
          </wa-tag>
        } @else {
          <wa-tag ngModel variant="neutral" [withRemove]="false" (waRemove)="deleteExclusionPreference(pref)">
                <span>{{
                    {
                      from: pref.begin,
                      to: pref.end
                    } | dateRange: dateFormat
                  }}</span>&nbsp;—&nbsp;<span>{{ pref.note }}</span>
          </wa-tag>
        }
      }
    </div>
    <br/>
  }
    <span> The exams of this semester take place during February 9 - April 11. Note that exams may be scheduled during the whole exam period, not only during the first and last weeks of the semester break.</span>
    <br/>
    <br/>
    <span> Please click on "+ add" on the top right to add time periods during which you are <b><u>not</u></b> available to supervise an exam.</span>

  </wa-card>
</div>
